module.exports = __webpack_public_path__ + "static/tickets_notify_me-dcc717be813e9b86845028a711dbe775.svg";